// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const FooterSocialInstagram: React.FC<{ size?: number; color1?: string; className?: string }> = ({
    size = 24,
    className,
}) => (
    <svg className={className} focusable="false" viewBox="0 0 24 24" width={size} height={size}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            d="M12 0c6.627 0 12 5.373 12 12s-5.373 12-12 12S0 18.627 0 12 5.373 0 12 0M9.113 5.044c-1.12.053-2.113.31-2.935 1.128-.822.819-1.075 1.812-1.131 2.934-.066 1.156-.066 4.622 0 5.778.053 1.122.31 2.116 1.131 2.935.822.818 1.813 1.075 2.934 1.131 1.157.066 4.622.066 5.779 0 1.121-.053 2.115-.31 2.934-1.131.819-.819 1.075-1.813 1.131-2.935.066-1.156.066-4.618 0-5.775-.053-1.121-.31-2.115-1.131-2.934-.819-.819-1.813-1.075-2.934-1.131-1.157-.066-4.622-.066-5.778 0m2.89 1.212c1.019 0 3.21-.081 4.128.281a2.36 2.36 0 0 1 1.331 1.332c.366.922.282 3.11.282 4.128s.084 3.21-.282 4.128a2.36 2.36 0 0 1-1.33 1.331c-.923.366-3.11.282-4.129.282s-3.21.08-4.128-.282a2.36 2.36 0 0 1-1.331-1.331c-.366-.922-.282-3.11-.282-4.128s-.08-3.21.282-4.128a2.36 2.36 0 0 1 1.331-1.332c.922-.365 3.11-.28 4.128-.28m0 2.15a3.585 3.585 0 0 0-3.59 3.59 3.585 3.585 0 0 0 3.59 3.591 3.585 3.585 0 0 0 3.59-3.59 3.585 3.585 0 0 0-3.59-3.59m0 1.257a2.337 2.337 0 0 1 2.334 2.334 2.34 2.34 0 0 1-2.334 2.334 2.34 2.34 0 0 1-2.334-2.334 2.337 2.337 0 0 1 2.334-2.334m3.738-2.241a.838.838 0 1 0 0 1.675.838.838 0 0 0 0-1.675"
        />
    </svg>
);

export default React.memo(FooterSocialInstagram);
